import { V1 } from 'api/v1/V1';
import { getClientTimeInISO } from 'library/utils/dateTime/clientTime';

export interface PrintUnitOverviewUserSettings {
	printQr: boolean;
	printConfiguration: boolean;
	printTechnicalInfo: boolean;
	printEndCustomer: boolean;
	printCampaigns: boolean;
	printCoverage: boolean;
	printProductInOperation: boolean;
	printCommissioning: boolean;
	printCommissioningChecksList: boolean;
	printSignatures: boolean;
}

export const UNIT_OVERVIEW_PDF_DEFAULTS: PrintUnitOverviewUserSettings = {
	printQr: true,
	printConfiguration: true,
	printTechnicalInfo: true,
	printEndCustomer: true,
	printCampaigns: true,
	printCoverage: true,
	printProductInOperation: true,
	printCommissioning: true,
	printCommissioningChecksList: false,
	printSignatures: true,
};

type GetUnitOverviewPdfRequest = Parameters<
	InstanceType<typeof V1>['downloadUnitOverviewPdf']
>['0'];

export const mapFormToUnitOverviewPdfRequest = (
	id: number,
	form: PrintUnitOverviewUserSettings,
	vppnReverseProxyType: string | undefined,
	isDealer: boolean,
	additionalText: string | undefined
): GetUnitOverviewPdfRequest => ({
	unitId: id,
	vppnReverseProxyType,
	additionalText: additionalText ?? '',
	// workaround for sending date as date, generated client sends it as string
	generationClientDate: getClientTimeInISO() as unknown as Date,
	printQr: isDealer ? form.printQr : false,
	printConfiguration: form.printConfiguration,
	printTechnicalInfo: form.printTechnicalInfo,
	printEndCustomer: form.printEndCustomer,
	printCampaigns: form.printCampaigns,
	printCoverage: form.printCoverage,
	printProductInOperation: form.printProductInOperation,
	printCommissioning: form.printCommissioning,
	printCommissioningCheckList: form.printCommissioningChecksList,
	printSignatures: form.printSignatures,
});

export const mapRecordToUnitOverviewUserSettings = (
	dict?: Record<string, boolean>
): PrintUnitOverviewUserSettings | undefined => {
	if (!dict) {
		return undefined;
	}

	const result = { ...UNIT_OVERVIEW_PDF_DEFAULTS };

	(Object.keys(result) as (keyof PrintUnitOverviewUserSettings)[]).forEach(
		(key) => {
			if (typeof dict[key] === 'boolean') {
				result[key] = dict[key];
			}
		}
	);

	return result;
};
